import React from 'react';
import { motion } from 'framer-motion';
import { Ornament } from './graphics/Graphics';
export function BarbaraStory() {
  return <section className="bg-cream py-12 md:py-20 px-5" data-id="element-16">
      <div className="max-w-[780px] mx-auto" data-id="element-17">
        {/* Header */}
        <motion.div initial={{
        opacity: 0,
        y: 10
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="mb-8" data-id="element-18">
          <div className="font-inter text-[12px] uppercase tracking-[0.1em] text-secondary mb-3" data-id="element-19">
            A Reader's Story
          </div>
          <h2 className="font-playfair text-[24px] md:text-[32px] text-ink font-semibold" data-id="element-20">
            Barbara, 63, Leeds
          </h2>
        </motion.div>

        {/* Hero Quote */}
        <motion.div initial={{
        opacity: 0,
        x: -20
      }} whileInView={{
        opacity: 1,
        x: 0
      }} viewport={{
        once: true
      }} className="border-l-[4px] border-gold bg-offwhite rounded-r-lg p-5 md:p-6 mb-8 shadow-subtle" data-id="element-21">
          <p className="font-playfair italic text-[18px] md:text-[22px] text-ink leading-relaxed" data-id="element-22">
            "I left a full trolley in the middle of Tesco and sat in my car and
            cried for 40 minutes. That was the day I stopped pretending I was
            managing."
          </p>
        </motion.div>

        {/* Photo & Body */}
        <div className="flow-root" data-id="element-23">
          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} className="w-full md:w-[50%] md:float-right md:ml-6 mb-6 md:mb-4" data-id="element-24">
            <img src="https://cdn.magicpatterns.com/uploads/uuFSgS5uzDTN1zhhmfC4Hv/hf_20260509_020137_9aaee5a0-d068-446b-be1e-902b77b8bbe9.png" alt="Barbara, 63" className="w-full h-auto rounded-xl shadow-subtle object-cover aspect-square md:aspect-[4/5]" data-id="element-25" />
            <p className="font-inter text-[12px] italic text-secondary mt-3 text-center md:text-left" data-id="element-26">
              Barbara, 63, from Leeds — 6 years of incontinence before finding
              DryControl
            </p>
          </motion.div>

          <div className="font-inter text-[16px] text-ink leading-[1.75] space-y-5" data-id="element-27">
            <p data-id="element-28">
              It started with a cough. Just a small leak, easily ignored. Then
              it was a sneeze. Then it was laughing too hard at a dinner party.
            </p>
            <p data-id="element-29">
              Within three years, Barbara's life had shrunk. She stopped taking
              her grandchildren to the park because she couldn't guarantee she'd
              make it to the public toilets in time. She started buying the
              heavy-duty pads she swore she'd never need.
            </p>
            <p data-id="element-30">
              "My GP told me it was just part of getting older," she says. "He
              told me to do my Kegels. I was doing them religiously, twice a
              day, for two years. It made absolutely no difference."
            </p>

            <div className="flex justify-center my-8" data-id="element-31">
              <Ornament color="#C9A96E" width={70} data-id="element-32" />
            </div>

            <p data-id="element-33">
              The turning point came in the frozen aisle at Tesco. A sudden
              urge, a sudden failure, and the crushing humiliation of leaving a
              full trolley behind.
            </p>

            <p data-id="element-34">
              That evening, searching for answers beyond the standard NHS
              advice, she found an article about the nerve-muscle connection and
              ordered her first box of DryControl.
            </p>

            <div className="flex justify-center my-8" data-id="element-35">
              <Ornament color="#C9A96E" width={70} data-id="element-36" />
            </div>

            {/* Day by Day Card */}
            <div className="bg-offwhite border border-divider rounded-xl p-6 md:p-7 my-8 shadow-subtle clear-both" data-id="element-37">
              <h3 className="font-inter font-semibold text-[16px] text-ink mb-5" data-id="element-38">
                What happened, day by day:
              </h3>

              <div className="space-y-4" data-id="element-39">
                <div className="flex flex-col sm:flex-row sm:items-start gap-1 sm:gap-4 border-b border-divider pb-4" data-id="element-40">
                  <div className="font-inter font-semibold text-[14px] text-forest sm:min-w-[80px] pt-0.5" data-id="element-41">
                    Day 4
                  </div>
                  <div className="font-inter text-[15px] text-ink" data-id="element-42">
                    "I sneezed while making tea. I braced myself, but nothing
                    happened. I thought it was a fluke."
                  </div>
                </div>

                <div className="flex flex-col sm:flex-row sm:items-start gap-1 sm:gap-4 border-b border-divider pb-4" data-id="element-43">
                  <div className="font-inter font-semibold text-[14px] text-forest sm:min-w-[80px] pt-0.5" data-id="element-44">
                    Day 6
                  </div>
                  <div className="font-inter text-[15px] text-ink" data-id="element-45">
                    "Woke up and realised I hadn't got up in the night. First
                    time in maybe four years."
                  </div>
                </div>

                <div className="flex flex-col sm:flex-row sm:items-start gap-1 sm:gap-4 border-b border-divider pb-4" data-id="element-46">
                  <div className="font-inter font-semibold text-[14px] text-forest sm:min-w-[80px] pt-0.5" data-id="element-47">
                    Day 7
                  </div>
                  <div className="font-inter text-[15px] text-ink" data-id="element-48">
                    "Went for a walk with my daughter. Didn't scan for toilets
                    once. The constant anxiety in the back of my mind was
                    just... gone."
                  </div>
                </div>

                <div className="flex flex-col sm:flex-row sm:items-start gap-1 sm:gap-4" data-id="element-49">
                  <div className="font-inter font-semibold text-[14px] text-forest sm:min-w-[80px] pt-0.5" data-id="element-50">
                    Day 14
                  </div>
                  <div className="font-inter text-[15px] text-ink" data-id="element-51">
                    "I threw away half a pack of Tena Ladies. I don't need them
                    anymore."
                  </div>
                </div>
              </div>
            </div>

            <div className="flex justify-center my-8" data-id="element-52">
              <Ornament color="#C9A96E" width={70} data-id="element-53" />
            </div>

            <p data-id="element-54">
              Barbara is now eight months into using DryControl. She applies a
              new patch every few days, entirely forgetting about it in between.
            </p>
          </div>
        </div>

        {/* Closing Quote */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-forest rounded-xl p-6 md:p-7 mt-8 shadow-subtle" data-id="element-55">
          <p className="font-playfair italic text-[20px] text-white leading-relaxed mb-4" data-id="element-56">
            "The frozen aisle is just a frozen aisle now. That is what I want to
            tell you. That is the whole of it."
          </p>
          <p className="font-inter text-[14px] text-white/60" data-id="element-57">
            — Barbara, 63, Leeds | 8 months after starting DryControl
          </p>
        </motion.div>
      </div>
    </section>;
}